var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-toolbar-section-end"},[_c('md-button',{staticClass:"md-just-icon md-simple md-toolbar-toggle",class:{ toggled: _vm.$sidebar.showSidebar },on:{"click":_vm.toggleSidebar}},[_c('i',{staticClass:"material-icons"},[_vm._v("menu")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }